import { AlertMessageSuccessIcon } from '../../icons/AlertMessageSuccessIcon';
import { ErrorIcon } from '../../icons/ErrorIcon';
import { OutlinedSemboIcon } from '../../icons/OutlinedSemboIcon';

export const ICONS = {
  success: AlertMessageSuccessIcon,
  error: ErrorIcon,
  info: OutlinedSemboIcon,
};
